import { ROUTES } from "@/shared/constants/routes";
import { addNotification } from "@/shared/states/notification";
import { NavigateFunction } from "react-router-dom";

export const handleSocketResponse = (
  response: any,
  navigate?: NavigateFunction,
) => {
  // Handle null/undefined response
  if (!response) {
    console.warn('handleSocketResponse called with null/undefined response');
    return;
  }

  // Handle non-object responses
  if (typeof response !== 'object') {
    console.warn('handleSocketResponse called with non-object response:', typeof response, response);
    return;
  }

  // Check for error status (only when status is exactly false)
  if (response.status === false) {
    addNotification({
      message:
        typeof response.message === "string"
          ? response.message
          : "Error in processing the file",
      type: "error",
    });
    navigate?.(`/${ROUTES.AGENT}`);
  }
};
